import {type z} from 'zod'

export const AT_LEAST_ONE_PROPERTY_MESSAGE = 'At least one property must be provided'

export function createPartialStrictObjectSchemaWithAtLeastOneProperty<T extends z.ZodObject<z.ZodRawShape>>(schema: T) {
    return schema.partial().refine((obj) => Object.keys(obj).length > 0, {
        message: AT_LEAST_ONE_PROPERTY_MESSAGE,
    })
}
